import { inject } from "mobx-react";
import React from "react";
import { useTranslation } from "react-i18next";
import type { Store } from "../../../client/stores";
import { ExternalLinkIcon } from "../components/icons/ExternalLinkIcon.componenet";
import { LiveIcon } from "../components/icons/LiveIcon.component";
import { PlayIcon } from "../components/icons/PlayIcon.component";
import { getLiveStationUrl } from "../lib/common";
import { MagicLink } from "../ui";
import "./StaticPlayer.style.scss";

interface StaticPlayerProps {
    store?: Store;
}

export const StaticPlayer = inject("store")(({ store }: StaticPlayerProps) => {
    if (!store) {
        return null;
    }
    // only show player bar if switch is true and there is a ihr_stream.id
    const { sections } = store.site;
    const playerUrl = getLiveStationUrl(store.site, store.env) || "";
    const { t } = useTranslation();
    const sectionName = "player_bar";

    if (sections.partners?.iheartradio_switch && playerUrl) {
        return (
            <div className="component-static-player">
                <div className="play-icon">
                    <MagicLink
                        to={playerUrl}
                        label={t("listen_live")}
                        target="_blank"
                        context="play_button"
                        sectionName={sectionName}
                    >
                        <PlayIcon />
                    </MagicLink>
                </div>
                <div className="station-info">
                    <p className="name-positioner">
                        <MagicLink to={playerUrl} target="_blank">
                            <span className="name">{sections.general?.name} &middot; </span>
                            <span className="positioner">{sections.general?.positioner}</span>
                        </MagicLink>
                    </p>
                    <p className="listen-now">
                        <MagicLink to={playerUrl} target="_blank" sectionName={sectionName} context="listen_now">
                            <ExternalLinkIcon />
                            <span>{t("listen_now")}</span>
                        </MagicLink>
                    </p>
                </div>
                <div className="live-indicator">
                    <MagicLink to={playerUrl} label={t("listen_live")} target="_blank">
                        <LiveIcon />
                    </MagicLink>
                </div>
            </div>
        );
    }
    return null;
});

export default StaticPlayer;
